import script from "./ShopifyWorkspace.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopifyWorkspace.vue?vue&type=script&setup=true&lang=js"

import "./ShopifyWorkspace.vue?vue&type=style&index=0&id=6593d9de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6593d9de"]])

export default __exports__